import { FaShareAlt, FaEdit, FaTrash, FaCloudDownloadAlt, FaPlay } from 'react-icons/fa';
import { IoIosEye } from 'react-icons/io';
import styles from './FileCard.module.css';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.heic'];
const VIDEO_EXTENSIONS = ['.mkv', '.mp4', '.avi', '.wmv', '.wav'];

/**
 * Botões de ação que aparecem sobre o card no hover, variando
 * conforme o tipo de arquivo e o nível de acesso do usuário.
 */
export default function FileCardActions({
  item,
  access,
  onView,
  onDownload,
  onPlay,
  onEdit,
  onDelete,
  onShare,
}) {
  const canManage = access <= 2;
  const isPdf = item.extension === '.pdf';
  const isImage = IMAGE_EXTENSIONS.includes(item.extension);
  const isVideo = VIDEO_EXTENSIONS.includes(item.extension);

  const stop = (e, handler) => {
    e.stopPropagation();
    handler();
  };

  return (
    <div className={styles.actions}>
      {isPdf && (
        <div className={`${styles.iconButtons} ${styles.iconButtonsView}`}>
          <button onClick={(e) => stop(e, onView)}>
            <IoIosEye />
          </button>
        </div>
      )}

      {!item.isDirectory && (
        <div className={`${styles.iconButtons} ${styles.iconButtonsDownload}`}>
          <button onClick={(e) => stop(e, onDownload)}>
            <FaCloudDownloadAlt className={styles.downloadIcon} />
          </button>
        </div>
      )}

      {isImage && (
        <div className={`${styles.iconButtons} ${styles.iconButtonsView}`}>
          <button onClick={(e) => stop(e, onView)}>
            <IoIosEye />
          </button>
        </div>
      )}

      {canManage && (
        <>
          {isVideo && (
            <div className={`${styles.iconButtons} ${styles.iconButtonsPlayer}`}>
              <button onClick={(e) => stop(e, onPlay)}>
                <FaPlay className={styles.playIcon} />
              </button>
            </div>
          )}
          <div className={`${styles.iconButtons} ${styles.iconButtonsEdit}`}>
            <button onClick={(e) => stop(e, onEdit)}>
              <FaEdit />
            </button>
          </div>
          <div className={`${styles.iconButtons} ${styles.iconButtonsTrash}`}>
            <button onClick={(e) => stop(e, onDelete)}>
              <FaTrash />
            </button>
          </div>
        </>
      )}

      <div className={`${styles.iconButtons} ${styles.iconButtonsShare}`}>
        <button onClick={(e) => stop(e, onShare)}>
          <FaShareAlt />
        </button>
      </div>
    </div>
  );
}